import React, { useState } from 'react';
import JiraTaskModal from './JiraTaskModal';

const UrgentActions = ({ urgentActions, projectName }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState({ summary: '', description: '' });

  if (!urgentActions || urgentActions.length === 0) {
    return null;
  }

  const handleCreateJiraTask = (action, index) => {
    let summary = `Code Quality: Urgent Action ${index + 1}`;
    let descriptionText = action;

    const titleMatch = action.match(/\[Title\]:\s*(.*?)(?=\s*\[Description\]:|$)/i);
    const descMatch = action.match(/\[Description\]:\s*([\s\S]*)$/i);

    if (titleMatch) {
      summary = titleMatch[1].trim();
    }
    if (descMatch) {
      descriptionText = descMatch[1].trim();
    } else if (titleMatch) {
      descriptionText = ''; // If there's a title but no description tag, clear it or keep empty
    }

    const description = `*Urgent Action Required*\n\n${descriptionText}\n\n---\n_This issue was automatically created from the Code Quality Dashboard._`;
    setModalData({ summary, description });
    setModalOpen(true);
  };

  return (
    <>
      <div className="p-6 m-6 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg shadow-sm border-l-4 border-l-red-600">
        <div className="flex items-center gap-4 mb-5 pb-4 border-b-2 border-red-200 dark:border-red-800">
          <div className="text-3xl animate-pulse">🚨</div>
          <h2 className="text-xl font-bold text-red-700 dark:text-red-400 m-0">Urgent Actions Required</h2>
        </div>
        <div className="flex flex-col gap-4">
          {urgentActions.map((action, index) => (
            <div key={index} className="flex items-start gap-4 p-4 bg-white dark:bg-gray-800 rounded-lg shadow-sm border-l-4 border-l-red-600 transition-all duration-200 hover:translate-x-1 hover:shadow-md">
              <button 
                className="flex items-center gap-1.5 px-3 py-2 bg-red-600 hover:bg-red-700 text-white rounded-md text-sm font-semibold cursor-pointer transition-all shrink-0 shadow-sm"
                onClick={() => handleCreateJiraTask(action, index)}
                title="Create task in Jira"
                aria-label="Create task in Jira"
              >
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  viewBox="0 0 24 24" 
                  fill="currentColor"
                  className="w-4 h-4"
                >
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"/>
                </svg>
                Jira
              </button>
              <span className="min-w-[30px] h-8 bg-red-600 text-white rounded-full flex items-center justify-center font-bold text-sm shrink-0">{index + 1}</span>
              <span className="flex-1 text-red-700 dark:text-red-400 leading-relaxed text-base font-medium pt-0.5">{action}</span>
            </div>
          ))}
        </div>
      </div>

      <JiraTaskModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        initialSummary={modalData.summary}
        initialDescription={modalData.description}
        projectName={projectName}
      />
    </>
  );
};

export default UrgentActions;
